import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDateDisplay(d) {
  if (!d) return '-';
  const date = new Date(d);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${day < 10 ? '0' : ''}${day}/${month < 10 ? '0' : ''}${month}/${year}`;
}

export function getDaysUntilExpiry(expiryDate) {
  const expiry = expiryDate instanceof Date ? expiryDate : new Date(expiryDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diffMs = expiry.getTime() - today.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  return diffDays;
}


export function base64ToFile(base64String, fileName = 'logo.png', mimeType = "image/png") {
  return new Promise((resolve, reject) => {
    try {
      const base64Data = base64String.replace(/^data:\w+\/\w+;base64,/, "");
      
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: mimeType });
      // Gunakan FileReader untuk membaca Blob
      const reader = new FileReader();
      reader.onloadend = () => {
        // Buat File dari Blob
        const file = new File([blob], fileName, { type: mimeType });
        resolve(file);
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(blob);
    } catch (error) {

      reject(null);
    }
  });
}